import navMenuItems from '../../scripts/nav/menuItems';
import metricsHelper from '@/scripts/metricsHelper';

// initial state
// shape: [{ id, quantity }]
const state = {
    splashDescription: null,
    breadCrumbLinks: [],
    pageTitle: null,
    menuGroup: null,
    menuItem: null,
    haveMessages: false,
    appMessages: [], //{ key, `title, type, text }
    message: null,
    messageTitle: null, //TODO: rename this to just message
    messageType: null,
    showMobileMenu: false,
    isLoading: false,
    isDownloading: false,
    isDirty: false,
    emitter: null
}

// getters
const getters = {
    displayData: (state, getters) => {
        return { splashDescription: state.splashDescription, breadCrumbLinks: state.breadCrumbLinks, pageTitle: state.pageTitle };
    },
    getMessage: (state, getters) => {
        return state.message;
    },
    getMessageTitle: (state, getters) => {
        return state.messageTitle;
    },
    getMessageType: (state, getters) => {
        return state.messageType;
    },
    getMenuGroup: (state, getters) => {
        return state.menuGroup;
    },
    getMenuItem: (state, getters) => {
        return state.menuItem;
    },
    getShowMobileMenu: (state, getters) => {
        return state.showMobileMenu;
    },
    getIsLoading: (state, getters) => {
        return state.isLoading;
    }
}
function commitMessage(commit, messageType, message, messageTitle) {
    commit('setMessage', { messageType, message, messageTitle });
}
// actions
const actions = {
    setEmitter({ commit, state }, emitter) {
        commit('setEmitter', emitter);
    },
    setTitle({ commit, state }, { pageTitle, splashDescription }) {
        commit('setPageTitle', pageTitle);
        commit('setSplashDescription', splashDescription);
        commit('setTheCrumbs', []);
    },
    setBreadCrumbs({ commit, state }, breadCrumbs) {
        commit('setTheCrumbs', breadCrumbs);
    },
    setPage({ commit, state }, name) {
        metricsHelper.pageLoaded(name);
        var pageItem = navMenuItems.menuItems.byName[name];
        if (!pageItem) console.log(`Page ${name} not found`);
        // history.pushState(
        //     {
        //         listingFormActive: v
        //     },
        //     null,
        //     `${window.location.pathname}\x`
        // );
        //history.replaceState({urlPath:'/some/page/on/stackoverflow'},"", pageItem.url)
        // window.location.origin = pageItem.url;
        // store.dispatch('display/setTitle', {
        //     pageTitle: 'Actions',
        //     breadCrumbs: [common.breadCrumbs.actions]
        // });
        // const depthIsOne = pageItem.isGroup || !pageItem.groupName;
        const breadCrumbLinks =
            pageItem.isGroup || !pageItem.groupName
                ? [pageItem]
                : [navMenuItems.menuItems.byName[pageItem.groupName], pageItem];

        const menuItem = pageItem.isGroup ? '' : pageItem.name;
        const menuGroup = pageItem.groupName;
        commit('initializeThePage ', {
            pageTitle: pageItem.title,
            menuGroup,
            menuItem,
            breadCrumbLinks
        });
        state.emitter.emit('menuGroupSelected', {
            menuGroup,
            menuItem
        });
    },
    setPageTitle({ commit, state }, pageTitle) {
        commit('setPageTitle', { pageTitle });

    },
    setMenu({ commit, state }, { menuGroup, menuItem }) {
        commit('setMenuGroup', menuGroup);
        commit('setMenuItem', menuItem);
        state.emitter.emit('menuGroupSelected', {
            menuGroup,
            menuItem
        });
    },
    clearMessages({ commit, state }) {
        commitMessages(commit, state, []);
    },
    setValidationMessages({ commit, state }, { validationMessages }) {

        const appMessages = validationMessages.messages.map((m, i) => ({
            id: i,
            key: m.key,
            severity: m.severity,
            text: m.message,
            title: m.messageTitle
        }));
        commitMessages(commit, state, appMessages);
    },
    setMessage({ commit, state }, { message, messageTitle }) {
        commitMessage(commit, 'i', message, messageTitle);
    },
    setErrorMessage({ commit, state }, { message, messageTitle }) {
        commitMessage(commit, 'e', message, messageTitle);
    },
    setWarningMessage({ commit, state }, { message, messageTitle }) {
        commitMessage(commit, 'w', message, messageTitle);
    },
    reverseShowMobileMenu({ commit, state }) {
        commit('setShowMobileMenu', !state.showMobileMenu);
    },
    setShowMobileMenu({ commit, state }, showMobileMenu) {
        commit('setShowMobileMenu', showMobileMenu);
    },
    setIsLoading({ commit, state }, isLoading) {
        commit('setIsLoading', isLoading);
    },
    setIsDownloading({ commit, state }, isDownloading) {
        commit('setIsDownloading', isDownloading);
    },
    setApiResultsMessages,
    setIsDirty({ commit, state }, { isDirty }) {
        commit('setIsDirty', { isDirty });
    },
    setReportLoadedMessage({ commit, state }) {
        commitMessage(commit, 'r', 'The last analysis you requested has completed.  Would you like to view that report now or delete it?', 'Report Complete')
    }
}

function setApiResultsMessages(
    { commit, state },
    { response, defaultErrorMessage }
) {
    const meta = response ? response.meta : {};
    if (response && response.messages && !meta.messages)
        meta.messages = response.messages;
    let appMessages = [];
    if (response && meta.messages && meta.messages.length > 0) {
        appMessages = meta.messages.map((m, i) => ({
            id: i,
            // key: m.key,
            severity: getSeverity(m.messageType || m.severity),
            text: m.message
            //title: m.messageTitle
        }));
        commitMessages(commit, state, appMessages);
    } else if (!response || !meta || !meta.wasSuccessful) {
        appMessages = [
            {
                id: 1,
                // key: m.key,
                severity: 'e',
                text: defaultErrorMessage || 'Unexpected error'
                //title: m.messageTitle
            }
        ];
        commitMessages(commit, state, appMessages);
    }
}

function commitTheMessage(commit, state, severity, message, messageTitle) {
    commitMessages(commit, state, [
        {
            id: 1,
            key: null,
            severity: severity,
            text: message,
            title: messageTitle
            //key
            //,
        }
    ]);
}

function commitMessages(commit, state, appMessages) {
    commit('setMessages', { appMessages });
    if (appMessages && appMessages.length > 0)
        state.emitter.emit('hasMessages');
}

function getSeverity(apiSeverity) {
    if (!apiSeverity) return 'e'; //Default to error
    switch (apiSeverity.toLowerCase()) {
        case 'error':
            return 'e';
        case 'e':
            return 'e';
        case 'information':
            return 'i';
        case 'i':
            return 'i';
        case 'warning':
            return 'w';
        case 'w':
            return 'w';
    }
}
// mutations
const mutations = {
    setEmitter(state, emitter) {
        state.emitter = emitter;
    },
    setSplashDescription(state, splashDescription) {
        state.splashDescription = splashDescription
    },
    setTheCrumbs(state, breadCrumbLinks) {
        state.breadCrumbLinks = breadCrumbLinks;
    },
    setPageTitle(state, pageTitle) {
        state.pageTitle = pageTitle;
    },
    setMenuGroup(state, menuGroup) {
        state.menuGroup = menuGroup;
    },
    setMenuItem(state, menuItem) {
        state.menuItem = menuItem;
    },
    setMessages(state, { appMessages }) {
        state.appMessages = appMessages;
        state.haveMessages = appMessages.length > 0;
    },
    setMessage(state, { messageType, message, messageTitle }) {
        state.message = message;
        state.messageType = messageType;
        state.messageTitle = messageTitle;
    },
    setIsLoading(state, isLoading) {
        state.isLoading = isLoading;
    }

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
